import { render, staticRenderFns } from "./SingleUploads.vue?vue&type=template&id=ea916296&scoped=true&"
import script from "./SingleUploads.vue?vue&type=script&lang=js&"
export * from "./SingleUploads.vue?vue&type=script&lang=js&"
import style0 from "./SingleUploads.vue?vue&type=style&index=0&id=ea916296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea916296",
  null
  
)

export default component.exports